import {Question} from '@/types/content/Question';

export const Chapter1Questions: Question[] = [
  {
    headline: '第1章　中古自動車査定制度と査定士',
    introduction: '次の文章につき、正しい場合には〇、正しくない場合には×を押してください。',
    text: 'この制度は、消費者の保護並びに自動車の流通秩序維持の観点から設けられたものである。',
    answers: [
      {
        label: '〇',
        correct: true,
      },
      {
        label: '×',
        correct: false,
      },
    ],
    description: 'この制度は、中古自動車の商取引が正常に行われ、当事者の一方である消費者の利益も確保されることを目的としており、それが円滑に運ぶために必要な事項が査定制度運営規程として定められました。\n\n※テキストP8　(1)制度の目的を参照してください。',
    imageFilePath: null,
    exampleImageFilePath: null,
  },
  {
    headline: '第1章　中古自動車査定制度と査定士',
    introduction: '次の文章につき、正しい場合には〇、正しくない場合には×を押してください。',
    text: '技能検定に合格した中古自動車査定士は、自社で取りきめた査定基準で査定を行なうことができる。',
    answers: [
      {
        label: '〇',
        correct: false,
      },
      {
        label: '×',
        correct: true,
      },
    ],
    description: '査定業務実施店が査定を行うには、協会が定めた中古自動車査定基準によって行うことと定められています。\n\n※テキストP10　(5)査定の方法を参照してください。',
    imageFilePath: null,
    exampleImageFilePath: null,
  },
  {
    headline: '第1章　中古自動車査定制度と査定士',
    introduction: '次の文章につき、正しい場合には〇、正しくない場合には×を押してください。',
    text: '技能検定試験に合格した者のうち、年齢１８歳以上の者は査定業務実施店に所属し、また普通自動車第一種運転免許以上の取得を確認のうえ査定士として登録される。',
    answers: [
      {
        label: '〇',
        correct: true,
      },
      {
        label: '×',
        correct: false,
      },
    ],
    description: '年齢18歳未満、査定業務実施店に所属していない、また普通自動車第一種免許以上を取得していない場合は、技能検定に合格しても査定士として登録されません。\n\n※テキストP12　(11)査定士証を参照してください。',
    imageFilePath: null,
    exampleImageFilePath: null,
  },
];
